import { render, staticRenderFns } from "./TeachingWorkCorrectForm.vue?vue&type=template&id=c55bf63e"
import script from "./TeachingWorkCorrectForm.vue?vue&type=script&lang=js"
export * from "./TeachingWorkCorrectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports